import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  ListGroup,
  Badge,
} from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import CategoryForm from "../../components/categories/CategoryForm";
import {
  fetchCategories,
  createCategory,
  deleteCategory,
} from "../../service/apiService";

export default function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    const res = await fetchCategories();
    if (res.status === "success") {
      setCategories(res.data);
    }
  };

  const handleCreate = async (name) => {
    const res = await createCategory({ name });
    if (res.status === "success") {
      loadCategories();
    }
  };

  const confirmDelete = async () => {
    if (!categoryToDelete) return;

    const res = await deleteCategory(categoryToDelete.id);
    if (res.status === "success") {
      loadCategories();
    }

    setShowDeleteModal(false);
    setCategoryToDelete(null);
  };

  return (
    <Container fluid className="admin-page">
      <PageHeader
        title="Categories Manager"
        subtitle="Create and manage your contact categories"
      />

      <Row>
        <Col md={6} lg={5}>
          <Card className="shadow-sm border-0 mb-3">
            <Card.Body>
              <CategoryForm onCreate={handleCreate} />
            </Card.Body>
          </Card>

          <Card className="shadow-sm border-0">
            <Card.Header className="fw-bold">All Categories</Card.Header>
            <ListGroup variant="flush">
              {categories.map((cat) => (
                <ListGroup.Item
                  key={cat.id}
                  className="d-flex justify-content-between align-items-center"
                >
                  <span>{cat.name}</span>
                  <div>
                    <Badge bg="secondary" className="me-2">
                      {cat.contact_count ?? 0}
                    </Badge>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        setCategoryToDelete(cat);
                        setShowDeleteModal(true);
                      }}
                    >
                      ✕
                    </Button>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card>
        </Col>
      </Row>

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Category</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete{" "}
          <strong>{categoryToDelete?.name}</strong>?
          <br />
          This action cannot be undone.
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
